import { SoundData } from "./SoundData";

export class SettingsWebPortal {
  id: string = '';
  timeForRemoveNotification!: number;
  availableSounds!: SoundData[]
  currentSoundTrack!: string;
}
